var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path, _path2, _rect2, _rect3, _circle12, _circle13, _path3, _circle14, _circle15, _ellipse, _ellipse2, _ellipse3, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#f2a2b8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#f3adc0",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 52,
    r: 9,
    fill: "#7b3f22"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 42,
    r: 9,
    fill: "#7b3f22"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 33,
    r: 9,
    fill: "#7b3f22"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 26,
    r: 9,
    fill: "#7b3f22"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 22,
    r: 9,
    fill: "#7b3f22"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 22,
    r: 9,
    fill: "#7b3f22"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 26,
    r: 9,
    fill: "#7b3f22"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 33,
    r: 9,
    fill: "#7b3f22"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 42,
    r: 9,
    fill: "#7b3f22"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 52,
    r: 9,
    fill: "#7b3f22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#f2c14e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98L44 124L76 124L86 98C80 94 74 92 70 92L70 108L50 108L50 92C46 92 40 94 34 98Z",
    fill: "#3f6aa8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 92,
    width: 6,
    height: 16,
    fill: "#3f6aa8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 92,
    width: 6,
    height: 16,
    fill: "#3f6aa8"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 104,
    r: 1.6,
    fill: "#f2c14e"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 104,
    r: 1.6,
    fill: "#f2c14e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d4b090"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f1c8a4"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f1c8a4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f1c8a4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 61,
    r: 0.9,
    fill: "#9c826a"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 62.5,
    r: 0.9,
    fill: "#9c826a"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 63.5,
    r: 0.9,
    fill: "#9c826a"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 61,
    r: 0.9,
    fill: "#9c826a"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 62.5,
    r: 0.9,
    fill: "#9c826a"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 63.5,
    r: 0.9,
    fill: "#9c826a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bb9c7f",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55Q51 50 55 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55Q69 50 73 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47L56 47",
    stroke: "#7b3f22",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47L74 47",
    stroke: "#7b3f22",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67Q60 78 69 67Z",
    fill: "#fff",
    stroke: "#2a1d1a",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40 44C44 34 52 32 60 34C68 32 76 34 80 44C72 40 66 40 60 42C54 40 48 40 40 44Z",
    fill: "#7b3f22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait7);
export default __webpack_public_path__ + "static/media/player-portrait-7.84d6fb0c6823cf165a935993f96842ca.svg";
export { ForwardRef as ReactComponent };